<template lang="pug">
	.tracking-native-reports-control
		.date
			input.form-control(type="date" :value="getMondayOfLastWeek().toISOString().split('T')[0]" @input="dateRangeStart = $event.target.valueAsDate")
			input.form-control(type="date" :value="getSundayOfLastWeek().toISOString().split('T')[0]" @input="dateRangeEnd = $event.target.valueAsDate")

		.buttons
			button.btn.btn-sm.btn-outline-primary(type="button" v-on:click="downloadForThisVersion('days')")
				span Download report (days)
			button.btn.btn-sm.btn-outline-primary(type="button" v-on:click="downloadForThisVersion('raw')")
				span Download report (raw)
</template>

<script>

	import Screen 				from '../../../mixins/screen';
	import { Auth } 			from '../../../services/Auth';

	import { Creative } 			from '../../../services/Creative';
	import { Settings } 		from '../../../services/Settings';
	import { Version } 			from '../../../services/Version';
	import SetupSettings 		from "./../../../settings/settings";

	export default {
		name: "TrackNativeReports",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Switched",
				"Selected Version Fully Loaded",
				"Selected Version Setting Changed:end-card-version-id",
				"Settings Tab Changed:templates"
			]
		},
		props: ['setting'],
		data() {

			this.Creative = Creative;
			this.Settings = Settings;

			this.endCard = null;

			return {
				showed: true,
				dateRangeStart: this.getMondayOfLastWeek(),
				dateRangeEnd: this.getSundayOfLastWeek()
			}

		},
		methods: {
			getMondayOfLastWeek() {
				const today = new Date();
				const lastSunday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - (today.getDay() + 6) % 7);
				const lastMonday = new Date(lastSunday.getTime() - 6 * 24 * 60 * 60 * 1000);
				return lastMonday;
			},
			getSundayOfLastWeek() {
				const today = new Date();
				const lastSunday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - (today.getDay() + 6) % 7);
				return lastSunday;
			},

			downloadForThisVersion(type) {
				const from = this.dateRangeStart.toISOString().split('T')[0].replaceAll('-','');
				const to = new Date(this.dateRangeEnd.getTime() + 24 * 60 * 60 * 1000).toISOString().split('T')[0].replaceAll('-',''); // +1 day to include the last one

				// Токен добавляем в url, так как окно открывает браузер и заголовок подставить нельзя
				let url = Auth.addTokenToUrl(`//${SetupSettings["domain"]}/trackingReport/version/${Version.SelectedVersion.id}?from=${from}&to=${to}&type=${type}`);
				window.open(url, '_blank');
			}
		}
	}
</script>

<style lang="sass">

	.tracking-native-reports-control
		display: flex
		flex-direction: column
		gap: 8px
	
		.date
			display: flex
			gap: 8px

		.buttons
			display: flex
			justify-content: right
			gap: 8px

</style>
